import { Directive } from "@angular/core";
import { InquiryService } from "../services/inquiry.service";
import { ModalSnackbarService } from "../services/modal-snackbar.service";
import { AG_GRID_LOCALE_JP } from '../misc/ag-grid-locale';
import { Inquiry } from "../models/inquiry.model";
import { Router } from "@angular/router";

@Directive()
export abstract class AbstractInquiryListComponent {
  localeText = AG_GRID_LOCALE_JP;

  paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];

  showCompleted = false; // デフォルトは「完了は非表示」

  showCompletedStatus: string[] = ['完了'];
  category = 'inquiry';
  categoryName = 'お問い合わせ';

  allRows: Inquiry[] = []; // APIレスポンスを保持
  rowData: Inquiry[] = []; // 表示用データ

  constructor(
    protected service: InquiryService,
    protected snackBar: ModalSnackbarService,
    protected router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  applyFilter(): void {
    if (this.showCompleted) {
      this.rowData = this.allRows;
    } else {
      this.rowData = this.allRows.filter(row => !this.showCompletedStatus.includes(row.status as string));
    }
  }

  onToggleCompleted(): void {
    this.applyFilter();
  }

  load(): void {
    this.service.getAll(this.categoryName).subscribe({
      next: (res) => {
        this.allRows = res;
        this.applyFilter();
      },
      error: () => this.snackBar.show(this.categoryName + '一覧の取得に失敗しました')
    });
  }

  onRowClicked(event: any): void {
    const id = event.data.id;
    this.router.navigate(['/' + this.category, id]);
  }

}
